// Text with check or cross marks

import './MarkedText.scss';

const MARK_STYLES = {
  check: 'success fa-check-circle',
  cross: 'danger fa-cross-circle',
  clock: 'warning fa-clock',
};

export default function MarkedText({ text, mark, className }) {
  return (
    <div className={'marked-text' + (className ? ' ' + className : '')}>
      <p
        className={'mark' + (MARK_STYLES[mark] ? ' ' + MARK_STYLES[mark] : '')}
      />
      <p className='text'>{text}</p>
    </div>
  );
}
